// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\doctors\DoctorsPage\columns.js

import React from "react";
import { DeleteOutlined, EditOutlined, StarFilled, StopOutlined } from "@ant-design/icons";
import { Button, Space, Tag, Typography } from "antd";

const { Text } = Typography;

export const columns = (navigateTo, showModal, handleOpenDoctorHistory) => [
    {
        title: "Nom",
        dataIndex: "lastname",
        key: "lastname",
        width: 190, // Un peu plus large pour laisser la place aux badges
        render: (text, record) => {
            // Détection des différents profils
            const isAtRisk = record.relationshipCategory === 'PARTNER_AT_RISK';
            const isKeyPrescriber = record.relationshipCategory === 'KEY_PRESCRIBER';
            const isRefractory = 
                record.relationshipCategory === 'REFRACTORY' || 
                String(record.relationshipCategory || '').toUpperCase().includes('REFRACT') ||
                String(record.relationshipCategory || '').toUpperCase().includes('RÉCEPTIF');

            const isPartner = 
                !isAtRisk && !isRefractory && !isKeyPrescriber && (
                    record.relationshipCategory === 'PARTNER_ACTIVE' ||
                    record.isPartner === true || 
                    record.isPartner === 'true' || 
                    record.isPartner === 1
                );

            return (
                <Space size={4} wrap>
                    <a 
                        onClick={() => handleOpenDoctorHistory && handleOpenDoctorHistory(record.id)}
                        style={{ fontWeight: 'bold' }}
                    >
                        {text}
                    </a>
                    
                    {/* ⭐ Badge Partenaire Stratégique */}
                    {isPartner && (
                        <Tag color="gold" style={{ fontSize: '10px', fontWeight: 'bold', padding: '0 4px', lineHeight: '18px' }}>
                            <StarFilled /> STRATEGIQUE [B+]
                        </Tag>
                    )}

                    {/* ⚠️ Badge Partenaire Sous Vigilance */}
                    {isAtRisk && (
                        <Tag color="warning" style={{ fontSize: '10px', fontWeight: 'bold', padding: '0 4px', lineHeight: '18px' }}>
                            ⚠️ VIGILANCE [A-]
                        </Tag>
                    )}

                    {/* 🚀 Badge Prescripteur Clé */}
                    {isKeyPrescriber && (
                        <Tag color="success" style={{ fontSize: '10px', fontWeight: 'bold', padding: '0 4px', lineHeight: '18px' }}>
                            🚀 PRESCRIPTEUR [B]
                        </Tag>
                    )}

                    {/* ⛔ Badge Non Réceptif */}
                    {isRefractory && (
                        <Tag color="error" style={{ fontSize: '10px', fontWeight: 'bold', padding: '0 4px', lineHeight: '18px' }}>
                            <StopOutlined /> NON RÉCEPTIF [C-]
                        </Tag>
                    )}
                </Space>
            );
        },
    },
    {
        title: "Prénom",
        dataIndex: "firstname",
        key: "firstname",
        width: 120,
    },
    {
        title: "Personnes Assignées",
        dataIndex: "delegates",
        key: "delegates",
        width: 180,
        render: (delegates) => (
            <>
                {delegates && delegates.length > 0 ? (
                    <Space size={[0, 4]} wrap>
                        {delegates.map((delegate) => (
                            <Tag color="blue" key={delegate.id}>
                                {`${delegate.firstname || ''} ${delegate.lastname || ''}`.trim()}
                            </Tag>
                        ))}
                    </Space>
                ) : (
                    <Tag color="orange">Non assigné</Tag>
                )}
            </>
        ),
    },
    {
        title: "Spécialités",
        dataIndex: "doctor",
        key: "speciality",
        render: (data) => <>{data?.specialty?.abreviation || data?.specialty?.name || '-'}</>,
        width: 90,
    },
    {
        title: "Type",
        dataIndex: "doctor",
        key: "doctorType",
        render: (data) => <>{Number(data?.doctorType) === 1 ? "Hospitalier" : "Privé"}</>,
        width: 90,
    },
    {
        title: "Gouvernorat",
        dataIndex: "government",
        key: "gouvernorat",
        render: (data) => <>{data?.name || '-'}</>,
        width: 120,
    },
    {
        title: "Région",
        dataIndex: "region",
        key: "region",
        render: (data) => <>{data?.name || '-'}</>,
        width: 140,
    },
    {
        title: "Address",
        dataIndex: "address",
        key: "address",
        width: 250,
        ellipsis: true,
    },
    {
        title: "Téléphone",
        dataIndex: "phoneNumber",
        key: "phone",
        width: 120,
        ellipsis: true,
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 200,
    },
    {
        title: "Potentiel",
        dataIndex: "potential",
        key: "potential",
        width: 90,
        align: 'center',
        render: (text) => {
            const val = text ? text.trim().toUpperCase() : ''; 
            if (!val) return <Text type="secondary">-</Text>;

            let color = 'default';
            if (val === 'A+' || val === 'A') color = 'green';
            else if (val === 'B+' || val === 'B') color = 'blue';
            else if (val === 'C') color = 'orange';

            return (
                <Tag color={color} style={{ fontWeight: 'bold' }}>
                    {val}
                </Tag>
            );
        },
    },
    {
        title: "Action",
        key: "action",
        fixed: 'right',
        width: 150,
        render: (record) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Button
                    className="btn-details"
                    size="small"
                    onClick={() => navigateTo(`edit/médecin/${record.id}`)}
                    icon={<EditOutlined />}
                >
                    Modifier
                </Button>

                <Button 
                    type="text" 
                    danger 
                    size="small"
                    onClick={() => showModal(record.id)}
                    icon={<DeleteOutlined style={{ fontSize: '16px' }} />}
                />
            </div>
        ),
    },
];